export const isVlaams = (): boolean => {
  return import.meta.env.VITE_VLAAMSE_URLS.split(",").includes(
    window.location.hostname,
  );
};
